enum FormError {
    Unauthorized,
    UnexpectedError,
    UserError,
}

export default FormError;
